export const validations = (name: string, value: any, isRequired = false) => {
    if (
        !isRequired &&
        (value === "" || value === undefined || value === null)
    ) {
        return ""; // No error if the field is optional and value is empty
    }
    switch (name) {
        case "firstName":
        case "lastName":
        case "category":
        case "nameOfProduction":
        case "categoryName":
        case "first_name":
        case "last_name":
            if (value === "") {
                return "Please enter a value.";
            } else if (value.length < 2) {
                return "Minimum 2 characters are required.";
            } else if (value.length > 25) {
                return "Maximum 25 characters are allowed.";
            } else if (/[!@#$%^&*()_+=\[\]{};:\\|,<>\/?]+/.test(value)) {
                return "Special characters are not allowed.";
            }
            return "";

        case "companyName":
            if (value === "") {
                return "Please enter a value.";
            } else if (value.length < 2) {
                return "Minimum 2 characters are required.";
            } else if (value.length > 50) {
                return "Maximum 50 characters are allowed.";
            } else return "";

        case "isTermsAndConditionsAgree":
            if (!value) {
                return "Please agree terms and conditions";
            } else return "";

        case "email":
            if (value === "") {
                return "Please enter a value.";
            } else if (
                !value.match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                )
            ) {
                return "Please enter a valid email.";
            } else return "";
        case "current_password":
        case "new_password":
        case "password_confirmation":
        case "password":
            if (value === "") {
                return "Please enter a valid password.";
            } else if (value.length < 8) {
                return "Minimum 8 characters are required.";
            } else if (value.length > 15) {
                return "Maximum 16 characters are allowed.";
            } else return "";

        case "year":
            if (value === "") {
                return "Please enter a value.";
            } else if (!value.match(/^[0-9]*$/g) || value.length !== 4) {
                return "Please enter a valid year";
            } else return "";

        case "websiteUrl":
            if (value === "") {
                return "Please enter a value.";
            } else if (
                !value.match(
                    /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+\/?$/g
                )
            ) {
                return "Please enter a valid URL.";
            } else return "";

        case "interests":
        case "city":
        case "aboutCompany":
        case "roleDetails":
            if (value === "") {
                return "Please enter a value.";
            } else if (/[!@#$%^&*()_+=\[\]{};:\\|<>\/?]+/.test(value)) {
                return "Special characters are not allowed.";
            } else return "";

        case "dob":

        case "nationality":
        case "qualification":
        case "genres":
        case "zip":
        case "payType":
            if (value === "") {
                return "Please enter a value.";
            } else return "";

        case "eye_color":
        case "piercings":
        case "status":
        case "currency":
        case "ethnicity":
        case "gender":
        case "tattoos":
        case "hair_color":
        case "country":
        case "language_id":
        case "level":
        case "address":
        case "state":
        case "durationCycle":
            if (value === "" || !value || value === null) {
                return "Please select an option.";
            } else return "";

        case "socialUserName":
            if (value === "") return "Please enter a value.";
            else if (value.length < 2)
                return "Minimum 2 characters are required.";
            else if (value.length > 50)
                return "Maximum 50 characters are allowed.";
            else return "";

        case "my_story":
            if (value === "") {
                return "Please enter a value.";
            } else if (value.length > 1000)
                return "Maximum 1000 characters are allowed.";
            else if (/[!@#$%^&*()_+=\[\]{};:\\|<>\/?]+/.test(value)) {
                return "Special characters are not allowed.";
            } else return "";
        case "mobile_number":
            if (value === "") {
                return "Please enter a value.";
            } else if (!/^[0-9]{10,15}$/.test(value)) {
                return "Enter valid mobile number.";
            } else return "";
        case "mobile":
        case "phone":
        case "mobileNumber1":
        case "mobileNumber2":
            if (value === "") {
                return "Please enter a value.";
            } else if (value.length < 5)
                return "Minimum 5 characters are required.";
            else if (value.length > 15)
                return "Maximum 15 characters are allowed.";
            else return "";

        case "title":
            if (value === "") {
                return "Please enter a value.";
            } else if (value.length < 5)
                return "Minimum 5 characters are required.";
            else if (value.length > 100)
                return "Maximum 100 characters are allowed.";
            else if (/[!@#$%^&*()_+=\[\]{};:\\|,<>\/?]+/.test(value)) {
                return "Special characters are not allowed.";
            }
            return "";

        case "description":
            if (value === "") {
                return "Please enter a value.";
            } else if (value.length < 5)
                return "Minimum 5 characters are required.";
            else if (value.length > 300)
                return "Maximum 300 characters are allowed.";
            else if (/[!@#$%^&*()_+=\[\]{};:\\|<>\/?]+/.test(value)) {
                return "Special characters are not allowed.";
            }
            return "";

        case "minAmount":
        case "maxAmount":
        case "numberOfSeats":
        case "minHeight":
        case "maxHeight":
        case "minWeight":
        case "maxWeight":
        case "weight":
        case "height":
        case "hips":
        case "waist":
        case "bust":
        case "hair_length":
            if (Number(value) <= 0 || isNaN(Number(value))) {
                return "Please enter a valid number.";
            } else return "";

        default:
            return "";
    }
};
